/* eslint-disable prettier/prettier */
import {
  LayoutDashboard,
  Users,
  Folder,
  Files,
  Shield,
  GitCompareIcon,
  FileSignature,
  MoreHorizontal,
  Hotel,
  Send,
  Forward,
  Settings,
} from 'lucide-react';

export const NAV_ITEMS = {
  SUPER_ADMIN: [
    { label: 'Dashboard', to: '/', icon: <LayoutDashboard /> },
    { label: 'Companies', to: '/companies', icon: <Hotel /> },
    { label: 'Users', to: '/users', icon: <Users /> },
    { label: 'Invitations', to: '/invitations', icon: <Forward /> },
  ],
  COMPANY_ADMIN: [
    { label: 'Dashboard', to: '/', icon: <LayoutDashboard /> },
    /*{ label: 'Users', to: '/users', icon: <Users /> },
    { label: 'Invitations', to: '/invitations', icon: <Forward /> },
    { label: 'Roles', to: '/roles', icon: <Shield /> },,*/
     { label: 'Settings', to: '/company-settings', icon: <Settings /> },
    { label: 'Folders', to: '/folders', icon: <Folder /> },
    { label: 'Files', to: '/files', icon: <Files /> },
    { label: 'Compare', to: '/compare', icon: <GitCompareIcon /> },
    /*{ label: 'Compare', to: '/compare-pv', icon: <GitCompareIcon /> },*/
  ],
  USER: [
    { label: 'Dashboard', to: '/', icon: <LayoutDashboard /> },
    { label: 'Folders', to: '/folders', icon: <Folder /> },
    { label: 'Files', to: '/files', icon: <Files /> },
    /*{ label: 'Compare', to: '/compare', icon: <GitCompareIcon /> },*/
    /*{ label: 'Compare', to: '/compare-pv', icon: <GitCompareIcon /> },,*/
  ],
};
